import { useSnackbar } from 'notistack';
import { useRef } from 'react';
export default function useToaster(props) {
    if (props === void 0) { props = {}; }
    var _a = useSnackbar(), enqueueSnackbar = _a.enqueueSnackbar, closeSnackbar = _a.closeSnackbar;
    var toasterStack = useRef([]);
    return {
        clearAllToasters: function () {
            toasterStack.current.forEach(closeSnackbar);
            toasterStack.current = [];
        },
        showToaster: function (_a) {
            var _b;
            var _c = _a.message, message = _c === void 0 ? '' : _c, _d = _a.variant, variant = _d === void 0 ? 'success' : _d;
            var options = {
                variant: variant,
                preventDuplicate: true,
                autoHideDuration: (_b = props.delay) !== null && _b !== void 0 ? _b : 5000
            };
            var key = enqueueSnackbar(message, options);
            toasterStack.current.push(key);
        }
    };
}
